module.exports = __webpack_public_path__ + "4f5f6548a44e94634aac0167df2f9074.pdf";